import Loadable from "@loadable/component";
import React from "react";
import LoadingPart from "../LoadingPart";


export default (loader: () => Promise<any>) => {
  return Loadable(loader, {
    fallback: <LoadingPart />,
  });
};
